import React from 'react';
import * as Sentry from "@sentry/react";

import ErrorScreen from './ErrorScreen';

interface ErrorBoundaryScreenProps {
  children?: React.ReactNode;
  type: string;
}

const ErrorBoundaryScreen: React.FC<ErrorBoundaryScreenProps> = ({ children, type }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={<ErrorScreen type={type} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default ErrorBoundaryScreen;
